const transaction = {
  preview_title: 'Transaction details',
  table: {
    title: 'All Transactions',
    CustomElementRegistry: 'Customer Name',
    phone: 'Customer phone',
    branch: 'Branch',
    amount: 'Gross Amount',
    net_amount: 'Net Amount',
    method: 'Payment method',
    date: 'Date',
    export_csv: 'Export CSV',
    export_pdf: 'Export PDF',
    payment_method_header:'Payment method',
    status: {
      paid: 'Completed',
      pending: 'Pending',
      rejected:'Rejected'
    },
    payment_method: {
      transfer: 'Account transfer',
      credit: 'Credit',
    }
  },
  modal: {
    amount_paid: 'Amount paid',

  },
  total_revenue: 'Total revenue',
  balance_before: "Balance before",
  balance_after: "Balance after",
  phone_number: "Phone number",
  tax_percentage: "Tax percentage",
  discount: 'Discount',
  reference: 'Reference',
  POS: 'POS',
  payment_method: "Payment method",
  transaction_date: "Transaction date",
  teller: "Teller",
  fee: 'Fee'
};

export default transaction;